export var CREHANA_DIPLOMAS_TRANSLATION_KEY = 'crehana-diplomas';
export var HOME_USER_AMPLITUDE_PAGE_NAME = 'Home User';
export var MAX_VISIBLE_DIPLOMAS = 6;